import { NavLink } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import { setDisplayMenu } from 'redux/app/appSlice';

import RouteNames from 'router/routes';

import MonitoringIcon from 'images/header/monitoring.svg?react';

import s from './navMonitoringPublic.module.css';

function NavMonitoringPublic() {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);

  const hideMenu = () => dispatch(setDisplayMenu(false));

  const navlinkStyles = ({ isActive }) =>
    isActive ? s.navlink_active : s.navlink;

  return (
    <ul className={s.navlinks_list}>
      <li>
        <NavLink
          to={RouteNames.MONITORING}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          <MonitoringIcon />
          {i18n.Онлайн_мониторинг}
        </NavLink>
      </li>
      <li>
        <NavLink
          to={RouteNames.LOGIN}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          {i18n.Вход}
        </NavLink>
      </li>
      <li>
        <NavLink
          to={RouteNames.SIGNUP}
          onClick={hideMenu}
          className={navlinkStyles}
        >
          {i18n.Регистрация}
        </NavLink>
      </li>
    </ul>
  );
}

export default NavMonitoringPublic;
